var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseFormulaireVolontaire',{attrs:{"typeFormulaire":"creationCompte","titleForm":"Création de votre compte"}})
}
var staticRenderFns = []

export { render, staticRenderFns }